<template>
  <!-- video -->
  <div class="notes-item notes-video" data-packed v-if="type === 'video'">
    <div class="pic" v-if="data.notePhotos && data.notePhotos.length" :style="`height:${200/data.notePhotos[0].imageWidth*data.notePhotos[0].imageHeight}px`">
      <router-link :to="`/notes/${data.noteInfo.id}`">
        <img :data-src="data.notePhotos[0].imageUrl | imageUrl" :src="data.notePhotos[0].imageUrl | imageUrl('?imageView2/2/w/400')" />
        <span class="icon-video-play" v-if="data.notePhotos[0].resourceType"></span>
      </router-link>
    </div>
    <div class="bar">
      <div class="avator"><img :data-src="data.userDetailInfo.logoUrl | imageUrl" :src="data.userDetailInfo.logoUrl | imageUrl('?imageView2/1/w/60/h/60')" /></div>
      <div class="name">{{data.userDetailInfo.nickName}}</div>
    </div>
  </div>
  <!-- un video -->
  <div class="notes-item" data-packed v-else>
    <div class="pic" v-if="data.notePhotos && data.notePhotos.length" :style="`height:${240/data.notePhotos[0].imageWidth*data.notePhotos[0].imageHeight < 428 ? 240/data.notePhotos[0].imageWidth*data.notePhotos[0].imageHeight : 428}px`">
      <router-link :to="`/notes/${data.noteInfo.id}`" target="_blank">
        <img :data-src="data.notePhotos[0].imageUrl | imageUrl" :src="data.notePhotos[0].imageUrl | imageUrl('?imageView2/2/w/480')" />
        <span class="icon-video-play" v-if="data.notePhotos[0].resourceType"></span>
      </router-link>
    </div>
    <div class="content" v-if="data.noteInfo.brief">
      <router-link :to="`/notes/${data.noteInfo.id}`" target="_blank">{{data.noteInfo.brief}}</router-link>
    </div>
    <div class="bar">
      <div class="avator"><img :data-src="data.userDetailInfo.logoUrl | imageUrl" :src="data.userDetailInfo.logoUrl | imageUrl('?imageView2/1/w/40/h/40')" /></div>
      <div class="name">{{data.userDetailInfo.nickName}}</div>
      <div class="time">{{data.noteInfo.createTime | formatDateTime}}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'NotesItem',
  props: { data: Object, type: String },
  mounted() {
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    init() {
      this.$emit('update')
    }
  }
}
</script>
<style>
.notes-item {
  width: 240px;
  padding-bottom: 8px;
}
.notes-item:hover .content {
  color: #1e88f5;
}
.notes-item .pic {
  position: relative;
  width: 100%;
  margin-bottom: 10px;
  border-radius: 4px;
  overflow: hidden;
  background-color: #e9ebf2;
}
.notes-item .pic img {
  width: 100%;
}
.notes-item .pic .icon-video-play {
  position: absolute;
  width: 50px;
  height: 50px;
  left: 50%;
  top: 50%;
  margin-left: -25px;
  margin-top: -25px;
  background: url('../../../assets/img/icon/icon-play@2x.png') no-repeat;
  background-size: 100%;
  cursor: pointer;
}
.notes-item .content {
  max-height: 120px;
  overflow: hidden;
  font-size: 14px;
  line-height: 20px;
  color: #666;
  white-space: normal;
  -webkit-line-clamp: 6;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
}
.notes-item .bar {
  margin-top: 8px;
  height: 20px;
  font-size: 12px;
  line-height: 20px;
}
.notes-item .bar .avator {
  float: left;
  width: 20px;
  height: 20px;
  line-height: 0;
  border-radius: 50%;
  overflow: hidden;
}
.notes-item .bar .avator img {
  width: 100%;
  height: 100%;
}
.notes-item .bar .name {
  float: left;
  max-width: 110px;
  margin-left: 6px;
  color: #3c3c3c;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.notes-item .bar .time {
  float: right;
  color: #999;
}
/* video */
.notes-item.notes-video {
  position: relative;
  width: 200px;
  padding-bottom: 0;
}
.notes-video .pic {
  margin-bottom: 0;
}
.notes-video .bar {
  position: absolute;
  left: 10px;
  bottom: 10px;
  height: 30px;
  line-height: 30px;
}
.notes-video .bar .avator {
  width: 30px;
  height: 30px;
}

.notes-video .bar .name {
  color: #fff;
}
</style>
